import React, { useState } from 'react';
import './Services.css';

const services = [
  {
    id: 'ai',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="10" stroke="currentColor" strokeWidth="2"/>
        <circle cx="24" cy="8" r="3" fill="currentColor"/>
        <circle cx="24" cy="40" r="3" fill="currentColor"/>
        <circle cx="8" cy="24" r="3" fill="currentColor"/>
        <circle cx="40" cy="24" r="3" fill="currentColor"/>
        <circle cx="11.5" cy="11.5" r="2.5" fill="currentColor" opacity=".6"/>
        <circle cx="36.5" cy="36.5" r="2.5" fill="currentColor" opacity=".6"/>
        <circle cx="36.5" cy="11.5" r="2.5" fill="currentColor" opacity=".6"/>
        <circle cx="11.5" cy="36.5" r="2.5" fill="currentColor" opacity=".6"/>
        <line x1="24" y1="14" x2="24" y2="11" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="24" y1="34" x2="24" y2="37" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="14" y1="24" x2="11" y2="24" stroke="currentColor" strokeWidth="1.5"/>
        <line x1="34" y1="24" x2="37" y2="24" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="24" cy="24" r="4" fill="currentColor"/>
      </svg>
    ),
    tag: 'Intelligence Layer',
    title: 'Artificial Intelligence',
    description: 'We architect and deploy AI systems that think, learn, and evolve. From custom LLMs to computer vision pipelines — our AI division builds the neural backbone of tomorrow.',
    features: ['Custom LLM Fine-tuning', 'Computer Vision', 'NLP & Chatbots', 'Predictive Analytics', 'AI Automation', 'MLOps & Deployment'],
    color: '#00d4ff',
  },
  {
    id: 'web',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="8" width="40" height="32" rx="4" stroke="currentColor" strokeWidth="2"/>
        <line x1="4" y1="16" x2="44" y2="16" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="10" cy="12" r="2" fill="currentColor" opacity=".6"/>
        <circle cx="16" cy="12" r="2" fill="currentColor" opacity=".6"/>
        <circle cx="22" cy="12" r="2" fill="currentColor" opacity=".6"/>
        <rect x="10" y="22" width="12" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="26" y="22" width="12" height="3" rx="1.5" fill="currentColor" opacity=".4"/>
        <rect x="26" y="27" width="8" height="3" rx="1.5" fill="currentColor" opacity=".4"/>
        <rect x="10" y="33" width="28" height="3" rx="1.5" fill="currentColor" opacity=".25"/>
      </svg>
    ),
    tag: 'Digital Fortresses',
    title: 'Web Development',
    description: 'We craft high-performance web fortresses — blazing-fast, infinitely scalable, pixel-perfect. From SaaS platforms to e-commerce empires, we build for dominance.',
    features: ['React / Next.js Apps', 'Node.js Backends', 'REST & GraphQL APIs', 'Cloud Deployments', 'Performance Optimization', 'Progressive Web Apps'],
    color: '#7b2fff',
  },
  {
    id: 'app',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="12" y="2" width="24" height="44" rx="5" stroke="currentColor" strokeWidth="2"/>
        <line x1="19" y1="8" x2="29" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="24" cy="41" r="2" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="16" y="14" width="16" height="20" rx="2" fill="currentColor" opacity=".1" stroke="currentColor" strokeWidth="1"/>
        <line x1="19" y1="19" x2="29" y2="19" stroke="currentColor" strokeWidth="1" opacity=".6"/>
        <line x1="19" y1="23" x2="26" y2="23" stroke="currentColor" strokeWidth="1" opacity=".6"/>
        <line x1="19" y1="27" x2="28" y2="27" stroke="currentColor" strokeWidth="1" opacity=".6"/>
      </svg>
    ),
    tag: 'Mobile Command',
    title: 'App Development',
    description: 'Native and cross-platform mobile applications engineered for performance and scale. iOS, Android, or unified — we deploy mission-critical apps to millions of users.',
    features: ['React Native & Flutter', 'iOS Swift & Android Kotlin', 'App Store Deployment', 'Push Notification Systems', 'Offline-First Architecture', 'Backend Integration'],
    color: '#ffd700',
  },
];

const extraServices = [
  { icon: '⬡', title: 'UI / UX Design', desc: 'Immersive, pixel-perfect interfaces that convert.' },
  { icon: '⬡', title: 'Cloud Architecture', desc: 'AWS, GCP, Azure — built for infinite scale.' },
  { icon: '⬡', title: 'Cybersecurity', desc: 'Fortify your digital perimeter against threats.' },
  { icon: '⬡', title: 'DevOps & CI/CD', desc: 'Automate. Deploy. Iterate at speed.' },
];

export default function Services() {
  const [activeTab, setActiveTab] = useState('ai');
  const active = services.find(s => s.id === activeTab);

  return (
    <section className="services section" id="services">
      <div className="grid-bg" />
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Our Capabilities</span>
          <h2 className="section-title">
            THE <span className="gradient-text">ARSENAL</span>
          </h2>
          <p className="section-desc">
            Three divisions. Infinite firepower. We don't just write code — we engineer digital supremacy.
          </p>
        </div>

        {/* Tab Selector */}
        <div className="services-tabs">
          {services.map(s => (
            <button
              key={s.id}
              className={`service-tab ${activeTab === s.id ? 'active' : ''}`}
              style={{ '--tab-color': s.color }}
              onClick={() => setActiveTab(s.id)}
            >
              <span className="tab-icon" style={{ color: s.color }}>{s.icon}</span>
              <span className="tab-label">{s.title}</span>
            </button>
          ))}
        </div>

        {/* Active Service Panel */}
        {active && (
          <div className="service-panel glass-card" key={active.id}>
            <div className="service-panel-left">
              <span className="service-tag" style={{ color: active.color }}>
                // {active.tag}
              </span>
              <h3 className="service-title">{active.title}</h3>
              <p className="service-desc">{active.description}</p>
              <div className="service-features">
                {active.features.map(f => (
                  <div className="feature-chip" key={f} style={{ '--chip-color': active.color }}>
                    <span className="feature-dot" style={{ background: active.color }} />
                    {f}
                  </div>
                ))}
              </div>
              <a href="#contact" className="btn-primary" style={{ marginTop: '36px' }}>
                <span>Start a Project</span>
              </a>
            </div>
            <div className="service-panel-right">
              <div className="service-visual" style={{ '--service-color': active.color }}>
                <div className="service-icon-wrap" style={{ color: active.color }}>
                  {active.icon}
                </div>
                <div className="service-rings">
                  <div className="ring ring-1" style={{ borderColor: active.color }} />
                  <div className="ring ring-2" style={{ borderColor: active.color }} />
                  <div className="ring ring-3" style={{ borderColor: active.color }} />
                </div>
                {/* code lines decoration */}
                <div className="code-block">
                  <div className="code-line"><span className="c-cyan">const</span> <span className="c-gold">blueclan</span> = {'{'}</div>
                  <div className="code-line pl">  <span className="c-purple">domain</span>: <span className="c-text">"{active.id}"</span>,</div>
                  <div className="code-line pl">  <span className="c-purple">power</span>: <span className="c-cyan">Infinity</span>,</div>
                  <div className="code-line pl">  <span className="c-purple">ready</span>: <span className="c-gold">true</span></div>
                  <div className="code-line">{'}'}</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Extra service grid */}
        <div className="extra-services">
          {extraServices.map(s => (
            <div className="extra-card glass-card" key={s.title}>
              <span className="extra-icon">{s.icon}</span>
              <h4 className="extra-title">{s.title}</h4>
              <p className="extra-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
